import React from 'react'
import axios from 'axios'
import types from './types'
import queryString from 'query-string'
import { showNotification, hideNotification } from './notifications'
import _ from 'lodash'
import util from '../helpers/util.helper'

import { RefreshButton } from '../components/common/NotificationAction.component'

axios.defaults.withCredentials = true

const apiHost = process.env.REACT_APP_IDENTITY_API_HOST

export function authenticateUser (email, password, qs) {
  return (dispatch) => {
    return dispatch({
      type: types.AUTHENTICATE_USER,
      payload: axios.post(`${apiHost}/auth/login`, { email, password })
    }).then(results => {
      if (results.value && results.value.data && !results.value.data.is_verified) {
        return
      }

      if (results.value && results.value.data && results.value.data.is_force_reset_password) {
        window.location.href = util.forwardClientQueryStringToPath('/password/update', qs)
        return
      }

      const params = queryString.parse(qs)
      if (params.clientId) {
        axios.get(`${apiHost}/v1/users/me/session`, { params: { clientId: params.clientId } })
          .then(response => {
            if (response.data.siteApplication && !_.isEmpty(response.data.siteApplication)) {
              if (response.data.siteApplication.postCallbackUrl) {
                const form = document.createElement('form')
                document.body.appendChild(form)
                form.method = 'POST'
                form.action = response.data.siteApplication.postCallbackUrl

                const tokenInput = document.createElement('input')
                tokenInput.name = 'token'
                tokenInput.type = 'hidden'
                tokenInput.value = response.data.token
                form.appendChild(tokenInput)
                if (params.return) {
                  const returnInput = document.createElement('input')
                  returnInput.name = 'returnPath'
                  returnInput.type = 'hidden'
                  returnInput.value = decodeURIComponent(params.return)
                  form.appendChild(returnInput)
                }
                form.submit()

                return
              }

              let returnURL = decodeURIComponent(params.return || response.data.siteApplication.callbackUrl)
              if (returnURL.indexOf('?') > -1) {
                returnURL += '&'
              } else {
                returnURL += '?'
              }
              returnURL += `token=${response.data.token}`

              const finalURL = `${response.data.siteApplication.baseUrl}${returnURL}`

              // TODO: temporary put here until the design is out
              window.parent.postMessage({ action: 'completed', redirectURL: finalURL }, process.env.REACT_APP_POSTMESSAGE_WHITELIST_URL)
              window.location.href = finalURL
            }
          })
      } else {
        setTimeout(
          () => {
            window.location.href = '/'
          },
          1000
        )
      }
    })
  }
}

export function setUserToBeReadySelfRegister (clientId) {
  return axios.put(`${apiHost}/v1/users/me/self_register`, {}, { params: { clientId } })
}

export function getUserSession (clientId) {
  return axios.get(`${apiHost}/v1/users/me/session`, { params: { clientId } })
}

export function setNeedVerify (data) {
  return dispatch => {
    return dispatch({ type: types.SET_NEED_VERIFY, data })
  }
}

export function checkNeedRegister (data) {
  return dispatch => {
    return dispatch({
      type: types.CHECK_NEED_REGISTER,
      payload: axios.post(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users`, data, { params: { checkup: 'yes' } })
    })
  }
}

export function registerUser (data) {
  return (dispatch) => {
    return dispatch({
      type: types.REGISTER_USER,
      payload: axios.post(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users`, data)
    }).then(d => d)
  }
}

export function verifyMagicCode (id, email, magicCode, clientIdInQueryString, additionalParams = {}) {
  return (dispatch) => {
    return dispatch({
      type: types.VERIFY_MAGIC_CODE,
      payload: axios.patch(`${apiHost}/v1/users/${id}`, { email, magic_code: magicCode, ...additionalParams })
    }).then(result => {
      const clientId = _.has(result, 'value.data.clientId') && result.value.data.clientId ? result.value.data.clientId : clientIdInQueryString
      if (clientId) {
        return dispatch({
          type: types.VERIFY_SEND_TOKEN,
          payload: axios.get(`${apiHost}/v1/users/me/session`, { params: { clientId } })
        })
      }

      return result
    })
  }
}

export function verifyAndSendToken (clientId) {
  return (dispatch) => {
    return dispatch({
      type: types.VERIFY_SEND_TOKEN,
      payload: axios.get(`${apiHost}/v1/users/me/session`, { params: { clientId } })
    })
  }
}

export function checkLoggedin () {
  return (dispatch) => {
    return dispatch({
      type: types.CHECK_LOGGEDIN,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/me`)
    }).then(data => data)
  }
}

export function getLoginProviderMethodForUser (email) {
  return (dispatch) => {
    return dispatch({
      type: types.GET_LOGIN_PROVIDER_INFO,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/auth/provider`, { params: { email } })
    }).then(data => data)
  }
}

export function verifyInviteToken (token) {
  return (dispatch) => {
    return dispatch({
      type: types.VERIFY_INVITE_TOKEN,
      payload: axios.patch(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/${token}`, { token })
    }).then(data => data)
  }
}

export function forgotPassword (data) {
  return (dispatch) => {
    return dispatch({
      type: types.FORGOT_PASSWORD,
      payload: axios.post(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/forgot`, data)
    }).then(data => data)
  }
}

export function reWelcome (data) {
  return (dispatch) => {
    return dispatch({
      type: types.REWELCOME,
      payload: axios.post(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/rewelcome`, data)
    }).then(data => data)
  }
}

export function resetPassword (data) {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_PASSWORD,
      payload: axios.post(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/forgot`, data)
    }).then(data => data)
  }
}

export function setPassword (token, password, confirmPassword) {
  return (dispatch) => {
    let url = ''
    let form = {}
    if (token) {
      url = `${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/${token}`
      form = { token, password }
    } else {
      url = `${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/me`
      form = {
        newPassword: password,
        confirmPassword
      }
    }
    return dispatch({
      type: types.SET_USER_PASSWORD,
      payload: axios.patch(url, form)
    }).then(data => data)
  }
}

export function updateUserProfile (id, data) {
  return (dispatch) => {
    return dispatch({
      type: types.UPDATE_USER_PROFILE,
      payload: axios.put(`${apiHost}/v1/users/me`, data)
    }).then(data => {
      dispatch(showNotification('Profile Updated'))
    }).catch((e) => {
      dispatch(showNotification('Profile not updated'))
    }).finally(() => setTimeout(function () {
      dispatch(hideNotification())
    }, 3000))
  }
}

export function updateUserAvatar (avatar) {
  return (dispatch) => {
    return dispatch({
      type: types.UPDATE_USER_AVATAR,
      payload: axios.put(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/me/avatar`, { avatar })
    }).then(data => {
      dispatch(showNotification('Avatar Updated!'))
    }).catch(err => {
      console.error(err)
      dispatch(showNotification('Avatar could not be updated'))
    })
  }
}

export function updateUserPassword (form) {
  return (dispatch) => {
    return dispatch({
      type: types.UPDATE_USER_PASSWORD,
      payload: axios.patch(`${apiHost}/v1/users/me`, form)
    }).then(data => {
      dispatch(showNotification(
        'Your password has been successfully updated. Please log in again with your new password.',
        null,
        React.createElement(RefreshButton, { buttonText: 'OK' }),
        true
      ))
    })
  }
}

export function deleteAvatar () {
  return (dispatch) => {
    return dispatch({
      type: types.DELETE_USER_AVATAR,
      payload: axios.delete(`${apiHost}/v1/users/me/avatar`)
    }).then(data => {
      dispatch(showNotification('Image cleared'))
      setTimeout(() => dispatch(hideNotification()), 3000)
    })
  }
}

export function changeFile (image) {
  return {
    type: types.CHANGE_FILE,
    payload: { image }
  }
}

export function changeCrop (crop, pixelCrop) {
  return {
    type: types.CHANGE_CROP,
    payload: { crop, pixelCrop }
  }
}

export function loadImage (img, crop) {
  return {
    type: types.LOAD_IMAGE,
    payload: { img, crop }
  }
}

export function logout () {
  return {
    type: types.LOGOUT_USER,
    payload: axios.post(`${apiHost}/auth/logout`)
  }
}

export function searchUsers (text, page = 0) {
  const MAX_LIMIT = 20

  return (dispatch) => {
    return dispatch({
      type: types.SEARCH_USERS,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users`, {
        params: {
          text,
          limit: MAX_LIMIT,
          offset: page * MAX_LIMIT
        }
      })
    }).then(data => {
      const total = parseInt(data.value.headers['x-result-total-count'] || 0)
      const limit = parseInt(data.value.headers['x-result-page-limit'] || MAX_LIMIT)
      const offset = parseInt(data.value.headers['x-result-start-offset'] || 0)

      return {
        users: data.value.data,
        pagination: {
          total,
          limit,
          offset,
          hasMore: offset + data.value.data.length < total
        }
      }
    })
  }
}

export function impersonateUser ({ id, uuid }) {
  return (dispatch) => {
    return dispatch({
      type: types.IMPERSONATE_USER,
      payload: axios.post(`${process.env.REACT_APP_IDENTITY_API_HOST}/auth/impersonate`, { user_id: id, uuid })
    }).then(data => data)
  }
}

export function getAvatar () {
  return axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/me/avatar?${new Date().getTime()}`)
}

export function getLocateEULAContent () {
  return axios.get(`${process.env.REACT_APP_LOCATE_API_HOST}/eula`)
}

export function getCollaborateEULAContent () {
  return axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/eula/collaborate`)
}

export function createCollaborateUserEULA (id, eulaId, eulaAcceptanceDateTime) {
  return axios.post(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/eula/collaborate`, { id, eulaId, eulaAcceptanceDateTime })
}
